import i18n from "src/locales";
import {
  CountryCode,
  getCountryCode,
  getLanguage,
  getMeristemContext,
} from "../meristemContext";

export const isEnLanguage = () => {
  return getLanguage() === "en";
};

export const isEnglishLanguageCounterOfferDropdown = () => {
  return (
    i18n.resolvedLanguage === "en" ||
    (i18n.resolvedLanguage && i18n.resolvedLanguage.startsWith("en")) // it could be en-US when first loaded
  );
};

export const isDeLanguage = () => {
  return getLanguage() === "de";
};

export const isEsLanguage = () => {
  return getLanguage() === "es";
};

export const isAU = () => {
  return getCountryCode() === "AU";
};

export const isUS = () => {
  return getCountryCode() === "US";
};

export const isCA = () => {
  return getCountryCode() === "CA";
};

export const isUK = () => {
  return getCountryCode() === "UK" || getCountryCode() === "GB";
};

export const isIE = () => {
  return getCountryCode() === "IE";
};

export const isDE = () => {
  return getCountryCode() === "DE";
};

export const isEU = () => {
  return getMeristemContext().is_eu_citizen;
};

export const isIntl = () => {
  return !isUS();
};

export const isCountry = (countries: CountryCode[]) => {
  return countries.includes(getCountryCode());
};

/**
 * Feet and pounds
 */
export const isCountryImperial = () => {
  return isCountry(["US", "CA"]);
};

/**
 * Kilos or stones and feet or meters
 */
export const isCountryBritishUnits = () => {
  return isUK() || isCountry(["IE"]);
};

/**
 * Kilos and meters
 */
export const isCountryMetric = () => {
  return !isCountryImperial() && !isCountryBritishUnits();
};

export const usesCapitalizedNouns = () => {
  return isDeLanguage();
};
